import { Icon } from "@chakra-ui/react"

const CheckInsIcon = () => {
  return (
    <Icon width='24px' height='24px' viewBox='0 0 24 24'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <rect
          x='3'
          y='5'
          width='18'
          height='16'
          rx='2'
          stroke='#999A9A'
          strokeWidth='1.5'
        />
        <path
          d='M3 9H21'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M8 3V7'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M16 3V7'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M8 14L11 17L16 12'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </Icon>
  )
}

export default CheckInsIcon
